import React from "react";

const QuizContent = ({ children, className = "" }) => {
  return <div className={`quiz-content ${className}`}>{children}</div>;
};

export default QuizContent;
